import React from "react";
import "../styles/Attribution.scss";

const Attribution: React.FC = () => {
  return (
    <div className="attribution-container">
      <a href="https://www.zevross.com">
        Application created by ZevRoss Spatial Analysis
      </a>
    </div>
  );
};

export default Attribution;
